import React from 'react';
import { motion } from 'framer-motion';
import { animationParams, animationVariants } from 'fragments';
import { LandingSvg } from 'assets';

export const TrustedCard = ({ customerAvatar, customerComment, customerName, customerProfession, rating }) => {
    return (
        <motion.div className="trusted-card-wrapper" {...animationParams} variants={animationVariants.cardsVariant}>
            <div className="trusted-card-stars-block">
                {rating &&
                    new Array(rating).fill(0).map((_, i) => <LandingSvg.StarOrangeSvg className="trusted-card-stars-block-svg" key={i} />)}
            </div>

            <p className="trusted-card-text">{customerComment}</p>

            <div className="trusted-card-info">
                <div className="trusted-card-info-img">
                    {customerAvatar ? <img src={customerAvatar} alt="Card Img" /> : customerName?.slice(0, 2).toUpperCase()}
                </div>

                <div className="trusted-card-name-position">
                    <p className="trusted-card-name">{customerName}</p>

                    <p className="trusted-card-position">{customerProfession}</p>
                </div>
            </div>
        </motion.div>
    );
};
